export default "__VITE_ASSET__LOGsMmWl__"